import { createValidator, validators as v } from 'ui-validator';

const isNotLendingClubEmail = createValidator((options, value) => {
  const opts = options || {};
  const val = value && value.trim();

  if (val && /^.+@lendingclub.com$/i.test(val))
    return opts.message || 'You are not able to use your LendingClub email. Please use another email address.';
});

const isSameAsPrimaryEmail = (value, key, attributes) => {
  const primaryEmail = attributes.primaryEmail;
  if (primaryEmail !== '' && value === primaryEmail) {
    return `${attributes.firstName !== '' ? attributes.firstName : 'Your co-borrower'}’s email cannot match your email`;
  }
};

const nameValidations = {
  firstName: {
    required: v.required({ message: 'The first name is required' }),
    twoNames: v.twoNames({
      message:
        "It appears that you have entered more than one individual's first name. Please apply using only one person's information.",
    }),
    isAlpha: v.customCondition({ condition: /[0-9]/, message: 'The first name may only contain letters' }),
    inputLength: v.inputLength({ max: 40, message: 'The first name must be less than 40 characters' }),
    suspicious: v.suspicious(),
  },
  lastName: {
    required: v.required({ message: 'The last name is required' }),
    isAlpha: v.customCondition({ condition: /[0-9]/, message: 'The last name may only contain letters' }),
    inputLength: v.inputLength({ max: 40, message: 'The last name must be less than 40 characters' }),
    suspicious: v.suspicious(),
  },
};

const emailSecondary = {
  required: v.required({ message: 'The email address is required' }),
  email: v.email(),
  notLCEmail: isNotLendingClubEmail(),
  inputLength: v.inputLength({ max: 50, key: 'Your email address' }),
  isSameAsPrimaryEmail,
};

const validations = (fieldName, hasCoApplicantEmail) => {
  const allValidations = nameValidations;
  if (hasCoApplicantEmail) {
    allValidations.emailSecondary = emailSecondary;
  }
  if (fieldName) {
    return {
      [fieldName]: allValidations[fieldName],
    };
  }

  return allValidations;
};

export default validations;

export { nameValidations };

